import LogIn from "../pages/auth/login";
import MustSubscribe from "../pages/auth/mustSubscribe";
import SignUp from "../pages/auth/signup";
import Dashboard from "../pages/dashboard";
import Market from "../pages/market";
import Settings from "../pages/settings";

const Routes = () => {
  const routes = [
    {path: "/", name: "LogIn", exact: true, component: <LogIn />, layout: "/"},
    {
      path: "/signup",
      name: "SignUp",
      exact: true,
      component: <SignUp />,
      layout: "/",
    },
    {
      path: "/mustSubscribe",
      name: "MustSubscribe",
      exact: true,
      component: <MustSubscribe />,
      layout: "/",
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      exact: true,
      component: <Dashboard />,
      layout: "/",
    },
    {
      path: "/market",
      name: "Market",
      exact: true,
      component: <Market />,
      layout: "/",
    },
    {
      path: "/settings",
      name: "Settings",
      exact: true,
      component: <Settings />,
      layout: "/",
    },

    {
      path: "/settings/myaccount",
      name: "Settings",
      exact: true,
      component: <Settings />,
      layout: "/",
    },
    {
      path: "/settings/profile",
      name: "Settings",
      exact: true,
      component: <Settings />,
      layout: "/",
    },
    {
      path: "/settings/privacy-safety",
      name: "Settings",
      exact: true,
      component: <Settings />,
      layout: "/",
    },
    {
      path: "/settings/payouts",
      name: "Settings",
      exact: true,
      component: <Settings />,
      layout: "/",
    },
    {
      path: "/settings/referral-links",
      name: "Settings",
      exact: true,
      component: <Settings />,
      layout: "/",
    },
    {
      path: "/settings/promo-material",
      name: "Settings",
      exact: true,
      component: <Settings />,
      layout: "/",
    },
    {
      path: "/settings/notifications",
      name: "Settings",
      exact: true,
      component: <Settings />,
      layout: "/",
    },
    {
      path: "/settings/subscriptions",
      name: "Settings",
      exact: true,
      component: <Settings />,
      layout: "/",
    },
    {
      path: "/settings/billing",
      name: "Settings",
      exact: true,
      component: <Settings />,
      layout: "/",
    },
    {
      path: "/settings/premium-plans",
      name: "Settings",
      exact: true,
      component: <Settings />,
      layout: "/",
    },
    {
      path: "/settings/send-gift",
      name: "Settings",
      exact: true,
      component: <Settings />,
      layout: "/",
    },
  ];
  return routes;
};

export default Routes;
